import React from 'react'

export const HobbiesTemplate = ({text}) => {
    return (
        <div className=" flex justify-center items-center rounded-lg p-4 w-1/12 m-1 text-xl" >
          {text}
        </div>
    )
}
